export const extractRelevantHeaders = (headers = {}) => {
  if (!headers) {
    return {};
  }

  const relevantHeaderKeys = ["content-type", "accept", "authorization"];
  const relevant = {};

  relevantHeaderKeys.forEach((key) => {
    if (headers[key]) {
      relevant[key] = headers[key];
    }
  });

  return relevant;
};
